import React, { useState } from 'react';

import { ModalDeleteBankDetails } from '../modalDeleteBankDetails';
import { BankDetailsDeleteCellProps } from './types';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSupplierContext } from 'contexts/complementaryRegistration';
import { IconButton, Tooltip } from '@material-ui/core';

export const DeleteBankDetailsCell = ({ row, personIdLogged }: BankDetailsDeleteCellProps) => {
  const [showModalDelete, setShowModalDelete] = useState(false);
  const handleOpenDeleteModal = () => setShowModalDelete(true);
  const handleCloseDeleteModal = () => setShowModalDelete(false);
  const { supplierData } = useSupplierContext();
  const disableDelete = supplierData.banksDetails.filter(({ operation }) => operation !== 'E').length === 1;

  return (
    <>
      <ModalDeleteBankDetails
        row={row}
        open={showModalDelete}
        handleClose={handleCloseDeleteModal}
        personIdLogged={personIdLogged}
      />
      <Tooltip title={disableDelete ? 'É obrigatório manter ao menos um dado bancário cadastrado!' : ''}>
        <span>
          <IconButton onClick={() => handleOpenDeleteModal()} disabled={disableDelete} style={{ cursor: 'pointer' }}>
            <DeleteIcon />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
